const meta = {
  concepts: 'Concepts',
  architecture: 'Architecture',
  security: 'Security',
  'release-notes': 'Release notes',
  'core-components': 'Component versions',
};

export default meta;
